// extracted by mini-css-extract-plugin
export var backgroundImage = "IntroBannerWithBackground-module--backgroundImage--6f3fb";
export var blueBackground = "IntroBannerWithBackground-module--blueBackground--b8daf";
export var buttonsWrapp = "IntroBannerWithBackground-module--buttonsWrapp--8e9b1";
export var intro = "IntroBannerWithBackground-module--intro--70b82";
export var search = "IntroBannerWithBackground-module--search--245a2";
export var section = "IntroBannerWithBackground-module--section--c3a37";
export var subtitle = "IntroBannerWithBackground-module--subtitle--d6f03";
export var textLogo = "IntroBannerWithBackground-module--textLogo--06a6f";
export var title = "IntroBannerWithBackground-module--title--94070";
export var white = "IntroBannerWithBackground-module--white--19a2e";